import React from "react";
import styled from "styled-components";
import { Spacing } from "@glossy/spacings";
import Button from "@ui-kit/button";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import { EmbeddedCard } from "@radarly/models/cards/model";
import Tile from "@radarly/shared/cards/tile";
import Embedded from "@radarly/shared/widgets/embedded";
import { CardProps } from "../model";

const PADDING_BOTTOM = 24;

const StyledButton = styled(Button)`
  margin-left: ${Spacing.Medium};
`;
const RadarlyEmbeddedCard = ({ card, height }: CardProps<EmbeddedCard>) => {
  const locale = useCurrentUserLocale();
  const dataviz = card.dataviz;
  return (
    <Tile
      title={card.title}
      height={height}
      actions={
        dataviz.displayLink ? (
          <StyledButton
            isDisabled={!dataviz.url}
            variant="tertiary"
            text={tr(locale, "INSIGHT_PAGES::GO_TO_CONTENT")}
            onClick={() => window.open(dataviz.url, "_blank")}
          />
        ) : (
          <div />
        )
      }
    >
      <Embedded
        dataviz={dataviz}
        height={height - PADDING_BOTTOM}
        locale={locale}
      />
    </Tile>
  );
};

export default RadarlyEmbeddedCard;
